import React, { Component } from 'react';
import {connect} from "react-redux";
import update from 'immutability-helper';
import {Alert, Button, Clearfix, Col, Form, FormControl, FormGroup, Glyphicon, Row} from "react-bootstrap";
import * as EmailValidator from 'email-validator';
import * as InviteActions from "../actions/InviteActions";
import {Link, Redirect} from "react-router-dom";
import {PRICE_PER_USER, STRIPE_API_KEY, TIER_FREE} from "../constants";
import * as TeamActions from "../actions/TeamActions";
import Loading from "../components/Loading";
import {CountryDropdown} from "react-country-region-selector";
import {LinkContainer} from "react-router-bootstrap";

let PENDING_SETTIMEOUT;
let STARTED_UPDATING_TEAM;

let stripe = window.Stripe(STRIPE_API_KEY);
let elements = stripe.elements();
let card = elements.create('card', {style: {
    base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
            color: '#aab7c4'
        }
    },
    invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
    }
}});

class UpgradePage extends Component {

    constructor(props){
        super(props);

        this.state = {
            stripeInitialized: false,
            message: undefined,
            errors: "",
            loading: false,
            form: {
                name: (props.user && props.user.name) || "",
                email: (props.user && props.user.email) || "",
                address: "",
                postalCode: "",
                country: "NL",
            },
            premiumOnStart: null,
            timeout: false
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.user){
            this.setState({form: update(this.state.form, {
                name: {$set: this.state.form.name || nextProps.user.name},
                email: {$set: this.state.form.email || nextProps.user.email}
            })})
        }


        // due something like to network issues
        if(nextProps.teams.billingError){
            this.setState({
                loading: false,
                message: {type: "danger", "title": "Error", message: "There was an error processing your billing details: " + (nextProps.teams.billingError)}
            });
        }

        console.log("showerror", nextProps.team, this.props.team, this.props.team && this.props.team.billingErrorDate, nextProps.team && nextProps.team.billingErrorDate)
        if(nextProps.team && this.props.team){
            let showError = false;

            // if already had error, only show if new error
            if (this.props.team.billingErrorDate && nextProps.team.billingErrorDate){
                if(nextProps.team.billingErrorDate.getTime() !== this.props.team.billingErrorDate.getTime()){
                    showError = true;
                }
            }
            // if there was no error before, show error
            if(!this.props.team.billingErrorDate && nextProps.team.billingErrorDate){
                showError = true;
            }

            if(showError){
                this.setState({
                    loading: false,
                    billingError: nextProps.team.billingError,
                });
                this.props.resetBillingAdded();
                STARTED_UPDATING_TEAM = null;
                if(PENDING_SETTIMEOUT) clearTimeout(PENDING_SETTIMEOUT);
            }
        }

        if(this.state.premiumOnStart === null){
            this.setState({premiumOnStart: nextProps.isPremium})
        }
        this.props.fetchTeamIfNeeded();
    }

    handleChange(event) {
        this.setState({form:
            update(this.state.form, {
                [event.target.name]: {$set: event.target.value}
            })
        });
    }
    handleCountryChange(country){
        this.setState(update(this.state, {form: {
            country: {$set: country}
        }}))
    }

    initStripe(){
        card.mount('#card-element');
        let _this = this;
        card.addEventListener('change', function (event) {
            if (event.error) {
                _this.setState({errors: event.error.message})
            } else {
                _this.setState({errors: ""})
            }
        });

        console.log("INIT STRIPE!")
        this.setState({stripeInitialized: true});
    }

    async submitForm(event) {
        event.preventDefault();

        this.setState({message: undefined});

        if (!this.state.form.name) {
            this.setState({message: {type: "danger", "title": "Error", message: "Please enter a valid name."}});
            return;
        }
        if (!this.state.form.email || !EmailValidator.validate(this.state.form.email)) {
            this.setState({message: {type: "danger", "title": "Error", message: "Please enter a valid e-mail address."}});
            return;
        }if (!this.state.form.address) {
            this.setState({message: {type: "danger", "title": "Error", message: "Please enter a valid address."}});
            return;
        }if (!this.state.form.postalCode) {
            this.setState({message: {type: "danger", "title": "Error", message: "Please enter a valid postal code."}});
            return;
        }if (!this.state.form.country) {
            this.setState({message: {type: "danger", "title": "Error", message: "Please select a country."}});
            return;
        }

        this.setState({loading: true});

        const ownerInfo = {
            owner: {
                name: this.state.form.name,
                email: this.state.form.email
            },
        };

        let _this = this;
        const stripeSource = await stripe.createSource(card, ownerInfo);

        const {source, error} = stripeSource;

        if (error) {
            _this.setState({errors: error.message});
            this.setState({loading: false});
            return;
        }

        this.props.addBilling({
            stripeSourceId: source.id,
            email: ownerInfo.owner.email || this.props.user.email,
            address: this.state.form.address,
            name: this.state.form.name || this.props.user.name,
            postalCode: this.state.form.postalCode,
            country: this.state.form.country
        })
    }

    retry(){
        this.props.retryBilling();
        this.setState({
            billingError: null,
            stripeInitialized: false,
            loading: false,
            timeout: false
        });
    }

    fetchTeamInASecond(){
        if(PENDING_SETTIMEOUT || this.props.teams.isFetching) return true;

        if(!STARTED_UPDATING_TEAM) STARTED_UPDATING_TEAM = new Date().getTime();

        if(new Date().getTime() - STARTED_UPDATING_TEAM > 60000){
            this.setState({timeout: true});
            return true;
        }

        PENDING_SETTIMEOUT = setTimeout(() => {
            this.props.fetchTeam();
            PENDING_SETTIMEOUT = undefined;
        }, 1000);

        return true;
    }

    render() {

        const {team, teams, isPremium, user} = this.props;
        const {message} = this.state;

        if(!team || !teams) return <Loading center loading/>;

        if(!user.admin) {
            return <Redirect to="/" />
        }

        if(this.state.premiumOnStart === true) return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Your already have a premium account
                    </h1>
                </div>
                <div className="card-footer">
                    <LinkContainer to = "/team">
                        <Button bsStyle="primary">
                            <Glyphicon glyph="chevron-left"/>&nbsp;
                            Go back
                        </Button>
                    </LinkContainer>
                    <Clearfix />
                </div>
            </div>
        );

        if(this.state.billingError || this.state.timeout) return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        An error occurred{this.state.timeout ? " (timeout)" : ""}
                    </h1>
                </div>
                <div className="card-body">
                    <Alert bsStyle="danger">
                        <h4>{this.state.billingError}</h4>
                    </Alert>
                    <p>Please try again or sent us an e-mail at <a href="mailto:support@t-rex.online">support@t-rex.online</a>.</p>
                    <Button onClick={this.retry.bind(this)}>Try again</Button>
                </div>
            </div>
        );

        if(teams.billingAdded && !isPremium && !this.state.billingError && this.fetchTeamInASecond()) return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Loading
                        <Loading right loading />
                    </h1>
                </div>
                <div className="card-body">
                    <p>Waiting for confirmation of your billing details.</p>
                </div>
            </div>
        );

        if(teams.billingAdded) return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Your account has been upgraded
                    </h1>
                </div>
                <div className="card-body">
                    <p>Thank you for upgrading your account! Your billing details have been added successfully. You can now make use of the premium features.</p>
                </div>
                <div className="card-footer">
                    <LinkContainer to = "/add-team-member">
                        <Button bsStyle="primary">
                            <Glyphicon glyph="plus"/>&nbsp;
                            Invite new user
                        </Button>
                    </LinkContainer>
                    <Clearfix />
                </div>
            </div>
        );

        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Upgrade to Premium
                        <small>{team.name}</small>
                        {!teams.billingAdded && !message && this.state.loading ? (
                            <Loading loading={true} right />
                        ) : (
                            <Link to = "/team">
                                <Button className="pull-right">
                                    <Glyphicon glyph="remove"/>
                                </Button>
                            </Link>
                        )}
                    </h1>
                </div>
                <div className="card-body">

                    {message && (
                        <Alert bsStyle={message.type} onDismiss={() => this.setState({message: null})}>
                            <h4>{message.title}</h4>
                            {message.message}
                        </Alert>
                    )}

                    <div>
                        Please provide us with a payment method to upgrade your account to the premium tier. The price per user is &euro;{parseFloat(Math.round(PRICE_PER_USER * 100) / 100).toFixed(2)} ex. VAT.
                        {this.state.text}
                        <Form horizontal style={{margin: "15px"}}>
                            <FormGroup>
                                <Row>
                                    <Col sm={3}>
                                        Name account holder
                                    </Col>
                                    <Col sm={9}>
                                        <FormControl componentClass="input" type="text" name="name" value={this.state.form.name} onChange={this.handleChange.bind(this)} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={3}>
                                        Contact e-mail address
                                    </Col>
                                    <Col sm={9}>
                                        <FormControl componentClass="input" type="text" name="email" value={this.state.form.email} onChange={this.handleChange.bind(this)} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={3}>
                                        Address
                                    </Col>
                                    <Col sm={9}>
                                        <FormControl componentClass="input" type="text" name="address" value={this.state.form.address} onChange={this.handleChange.bind(this)} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={3}>
                                        Postal code
                                    </Col>
                                    <Col sm={9}>
                                        <FormControl componentClass="input" type="text" name="postalCode" value={this.state.form.postalCode} onChange={this.handleChange.bind(this)} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={3}>
                                        Country
                                    </Col>
                                    <Col sm={9}>
                                        <CountryDropdown
                                            classes="form-control"
                                            value={this.state.form.country}
                                            valueType={"short"}
                                            onChange={country => this.handleCountryChange(country)}/>
                                    </Col>
                                </Row>
                            </FormGroup>

                            {!this.props.teams.addingBilling && !this.props.teams.billingAdded && !this.state.stripeInitialized && (
                                <FormGroup>
                                    <Row>
                                        <Col smOffset={3} sm={9}>
                                            <Button onClick={() => this.initStripe()}>Add Billing</Button>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            )}

                            <FormGroup>
                                <Row>
                                    <Col smOffset={3} sm={9}>
                                        <div id="card-element" />
                                        <div id="card-errors" role="alert">{this.state.errors}</div>
                                    </Col>
                                </Row>
                            </FormGroup>

                            {!this.props.teams.billingAdded && this.state.stripeInitialized && (
                                <FormGroup>
                                    <Row>
                                        <Col smOffset={3} sm={9}>
                                            <Button bsStyle="primary" onClick={this.submitForm.bind(this)} disabled={this.props.teams.addingBilling || this.state.loading}>
                                                Upgrade
                                            </Button>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            )}

                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    teams: state.teams,
    team: state.teams.active,
    user: state.users.active,
    isPremium: state.teams && state.teams.active && state.teams.active.tier !== TIER_FREE,
}), dispatch => ({
    createInvite: (name, email) => dispatch(InviteActions.createInvite({name, email})),
    addBilling: data => dispatch(TeamActions.addBilling(data)),
    fetchTeamIfNeeded: () => dispatch(TeamActions.fetchTeamIfNeeded()),
    fetchTeam: () => dispatch(TeamActions.fetchTeam()),
    retryBilling: () => dispatch(TeamActions.retryBilling()),
    resetBillingAdded: () => dispatch(TeamActions.resetBillingAdded())
}))(UpgradePage);


// WEBPACK FOOTER //
// ./src/pages/UpgradePage.js